/*
 * File: Post_Charges.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the Billing Order view
 */
import React from "react";
import PostChargesForm from "./components/PostChargesForm";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "services/patients/topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-3.5),
    marginTop: theme.spacing(2.5)
  }
});

const PostCharges = ({ classes, history }) => (
  <React.Fragment>
    <PatientChart />
    <Toolbar className={classes.toolbar}>
      <MainHeader pageTitle="Billing Order" pageSubtitle="Patient" />
    </Toolbar>
    <PostChargesForm history={history} />
  </React.Fragment>
);

PostCharges.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(styles)(PostCharges);
